// extracted by mini-css-extract-plugin
export default {"container":"Switch_container__-jJVO","switch":"Switch_switch__Cx63Q","slider":"Switch_slider__cygiN","round":"Switch_round__uhg3R"};